import React from "react";
import { RouteObject } from "react-router";
import { Redirect } from "src/router/helper/Redirect";

export const SystemSettingsRoutes: RouteObject[] = [
  {
    path: "",
    shouldRevalidate: () => false,
    loader: async (args) => {
      const { systemSettingsLoader } = await import("src/router/loaders/SystemSettings");
      return systemSettingsLoader(args);
    },
    async lazy() {
      const { SystemSettings } = await import("src/settings");
      return { element: <SystemSettings /> };
    },
    children: [
      {
        path: "statistics",
        async lazy() {
          const { GlobalStatistics } = await import("src/settings/GlobalStatisticsTab");
          return { element: <GlobalStatistics /> };
        },
      },
      {
        path: "patterns",
        async loader(args) {
          const { patternsLoader } = await import("src/router/loaders/SystemSettings");
          return patternsLoader(args);
        },
        async lazy() {
          const { PatternsTab } = await import("src/settings/PatternsTab");
          return { element: <PatternsTab /> };
        },
        children: [
          {
            path: ":patternId",
            async loader(args) {
              const { patternLoader } = await import("src/router/loaders/SystemSettings");
              return patternLoader(args);
            },
            async lazy() {
              const { EditPattern } = await import("src/settings/PatternsTab/EditPattern");
              return { element: <EditPattern /> };
            },
          },
          {
            path: "copy/:copyPatternId",
            async loader(args) {
              const { copyPatternLoader } = await import("src/router/loaders/SystemSettings");
              return copyPatternLoader(args);
            },
            async lazy() {
              const { EditPattern } = await import("src/settings/PatternsTab/EditPattern");
              return { element: <EditPattern /> };
            },
          },
        ],
      },
      {
        path: "reports",
        async lazy() {
          const { Reports } = await import("src/settings/ReportsTab");
          return { element: <Reports /> };
        },
      },
      {
        path: "*",
        element: <Redirect to="statistics" />,
      },
      {
        path: "",
        element: <Redirect to="statistics" />,
      },
    ],
  },
];
